module.exports = __webpack_public_path__ + "img/slog.e62553d0.gif";